declare namespace $ {

	type $shm_hitalama_vk_posts_plots_chart__title_shm_hitalama_vk_posts_plots_1 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_vk_posts_plots_chart['title'] >
	>
	type $shm_hitalama_vk_posts_plots_chart__group_ids_shm_hitalama_vk_posts_plots_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_posts_plots['owner_ids'] >
		,
		ReturnType< $shm_hitalama_vk_posts_plots_chart['group_ids'] >
	>
	type $shm_hitalama_vk_posts_plots_chart__group_name_shm_hitalama_vk_posts_plots_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_posts_plots['group_name'] >
		,
		ReturnType< $shm_hitalama_vk_posts_plots_chart['group_name'] >
	>
	type $shm_hitalama_vk_posts_plots_chart__series_y_shm_hitalama_vk_posts_plots_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_posts_plots['views'] >
		,
		ReturnType< $shm_hitalama_vk_posts_plots_chart['series_y'] >
	>
	type $shm_hitalama_vk_posts_plots_chart__labels_shm_hitalama_vk_posts_plots_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_posts_plots['labels'] >
		,
		ReturnType< $shm_hitalama_vk_posts_plots_chart['labels'] >
	>
	type $shm_hitalama_vk_posts_plots_chart__title_shm_hitalama_vk_posts_plots_6 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_vk_posts_plots_chart['title'] >
	>
	type $shm_hitalama_vk_posts_plots_chart__group_ids_shm_hitalama_vk_posts_plots_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_posts_plots['owner_ids'] >
		,
		ReturnType< $shm_hitalama_vk_posts_plots_chart['group_ids'] >
	>
	type $shm_hitalama_vk_posts_plots_chart__group_name_shm_hitalama_vk_posts_plots_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_posts_plots['group_name'] >
		,
		ReturnType< $shm_hitalama_vk_posts_plots_chart['group_name'] >
	>
	type $shm_hitalama_vk_posts_plots_chart__series_y_shm_hitalama_vk_posts_plots_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_posts_plots['posts'] >
		,
		ReturnType< $shm_hitalama_vk_posts_plots_chart['series_y'] >
	>
	type $shm_hitalama_vk_posts_plots_chart__labels_shm_hitalama_vk_posts_plots_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_posts_plots['labels'] >
		,
		ReturnType< $shm_hitalama_vk_posts_plots_chart['labels'] >
	>
	type $shm_hitalama_vk_posts_plots_chart__title_shm_hitalama_vk_posts_plots_11 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_vk_posts_plots_chart['title'] >
	>
	type $shm_hitalama_vk_posts_plots_chart__group_ids_shm_hitalama_vk_posts_plots_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_posts_plots['owner_ids'] >
		,
		ReturnType< $shm_hitalama_vk_posts_plots_chart['group_ids'] >
	>
	type $shm_hitalama_vk_posts_plots_chart__group_name_shm_hitalama_vk_posts_plots_13 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_posts_plots['group_name'] >
		,
		ReturnType< $shm_hitalama_vk_posts_plots_chart['group_name'] >
	>
	type $shm_hitalama_vk_posts_plots_chart__series_y_shm_hitalama_vk_posts_plots_14 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_posts_plots['likes'] >
		,
		ReturnType< $shm_hitalama_vk_posts_plots_chart['series_y'] >
	>
	type $shm_hitalama_vk_posts_plots_chart__labels_shm_hitalama_vk_posts_plots_15 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_posts_plots['labels'] >
		,
		ReturnType< $shm_hitalama_vk_posts_plots_chart['labels'] >
	>
	type $shm_hitalama_vk_posts_plots_chart__title_shm_hitalama_vk_posts_plots_16 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_vk_posts_plots_chart['title'] >
	>
	type $shm_hitalama_vk_posts_plots_chart__group_ids_shm_hitalama_vk_posts_plots_17 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_posts_plots['owner_ids'] >
		,
		ReturnType< $shm_hitalama_vk_posts_plots_chart['group_ids'] >
	>
	type $shm_hitalama_vk_posts_plots_chart__group_name_shm_hitalama_vk_posts_plots_18 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_posts_plots['group_name'] >
		,
		ReturnType< $shm_hitalama_vk_posts_plots_chart['group_name'] >
	>
	type $shm_hitalama_vk_posts_plots_chart__series_y_shm_hitalama_vk_posts_plots_19 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_posts_plots['reposts'] >
		,
		ReturnType< $shm_hitalama_vk_posts_plots_chart['series_y'] >
	>
	type $shm_hitalama_vk_posts_plots_chart__labels_shm_hitalama_vk_posts_plots_20 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_posts_plots['labels'] >
		,
		ReturnType< $shm_hitalama_vk_posts_plots_chart['labels'] >
	>
	type $shm_hitalama_vk_posts_plots_chart__title_shm_hitalama_vk_posts_plots_21 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_vk_posts_plots_chart['title'] >
	>
	type $shm_hitalama_vk_posts_plots_chart__group_ids_shm_hitalama_vk_posts_plots_22 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_posts_plots['owner_ids'] >
		,
		ReturnType< $shm_hitalama_vk_posts_plots_chart['group_ids'] >
	>
	type $shm_hitalama_vk_posts_plots_chart__group_name_shm_hitalama_vk_posts_plots_23 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_posts_plots['group_name'] >
		,
		ReturnType< $shm_hitalama_vk_posts_plots_chart['group_name'] >
	>
	type $shm_hitalama_vk_posts_plots_chart__series_y_shm_hitalama_vk_posts_plots_24 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_posts_plots['comments'] >
		,
		ReturnType< $shm_hitalama_vk_posts_plots_chart['series_y'] >
	>
	type $shm_hitalama_vk_posts_plots_chart__labels_shm_hitalama_vk_posts_plots_25 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_posts_plots['labels'] >
		,
		ReturnType< $shm_hitalama_vk_posts_plots_chart['labels'] >
	>
	type $mol_list__sub_shm_hitalama_vk_posts_plots_26 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['sub'] >
	>
	export class $shm_hitalama_vk_posts_plots extends $shm_hitalama_vk_posts_multi {
		group_name( id: any): string
		views( id: any): readonly(any)[]
		labels( ): readonly(string)[]
		Views( ): $shm_hitalama_vk_posts_plots_chart
		posts( id: any): readonly(any)[]
		Posts( ): $shm_hitalama_vk_posts_plots_chart
		likes( id: any): readonly(any)[]
		Likes( ): $shm_hitalama_vk_posts_plots_chart
		reposts( id: any): readonly(any)[]
		Reposts( ): $shm_hitalama_vk_posts_plots_chart
		comments( id: any): readonly(any)[]
		Comments( ): $shm_hitalama_vk_posts_plots_chart
		Charts( ): $mol_list
		Sub( ): ReturnType< $shm_hitalama_vk_posts_plots['Charts'] >
	}
	
}

//# sourceMappingURL=plots.view.tree.d.ts.map